// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.developer-info-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  background-color: #f2f2f2;
}

.developer-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 22px;
  background-color: #ffffff;
  border-bottom: 3px solid var(--netsfere-red);
}

.developer-info-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.developer-info-header-button {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: background-color 0.2s ease, color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.developer-info-header-button:hover {
  background-color: rgba(0, 0, 0, 0.06);
  color: #374151;
}

.developer-info-header-button ion-icon {
  font-size: 1.5rem;
}

.developer-info-content {
  padding: 4px 0 32px;
  flex-grow: 1;
  overflow-y: auto;
  background-color: #f2f2f2;
}

.info-section {
  margin-bottom: 0;
}

.info-section-header {
  background: rgba(0, 0, 0, 0.1);
  padding: 6px;
  font-size: 14px;
  font-weight: bold;
  color: rgb(51, 51, 51);
  margin-top: 20px;
  margin-left: 35px;
  margin-right: 5px;
}

.info-item {
  margin-left: 40px;
  font-size: 14px;
  min-height: 20px;
  display: flex;
  margin-top: 10px;
}

.info-label {
  width: 35%;
  overflow: hidden;
  font-size: 14px;
  font-weight: normal;
  color: rgb(51, 51, 51);
}

.info-value {
  width: 65%;
  float: right;
  word-wrap: break-word;
  line-height: 1.5;
  font-size: 14px;
  font-weight: normal;
  color: rgb(51, 51, 51);
}

.info-section-content {
  margin: 14px 5px 0 35px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/DeveloperInfoPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,4CAA4C;AAC9C","sourcesContent":[".developer-info-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  font-family: 'Roboto', sans-serif;\n  background-color: #f2f2f2;\n}\n\n.developer-info-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 22px;\n  background-color: #ffffff;\n  border-bottom: 3px solid var(--netsfere-red);\n}\n\n.developer-info-header-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333333;\n}\n\n.developer-info-header-button {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.developer-info-header-button:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n  color: #374151;\n}\n\n.developer-info-header-button ion-icon {\n  font-size: 1.5rem;\n}\n\n.developer-info-content {\n  padding: 4px 0 32px;\n  flex-grow: 1;\n  overflow-y: auto;\n  background-color: #f2f2f2;\n}\n\n.info-section {\n  margin-bottom: 0;\n}\n\n.info-section-header {\n  background: rgba(0, 0, 0, 0.1);\n  padding: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  color: rgb(51, 51, 51);\n  margin-top: 20px;\n  margin-left: 35px;\n  margin-right: 5px;\n}\n\n.info-item {\n  margin-left: 40px;\n  font-size: 14px;\n  min-height: 20px;\n  display: flex;\n  margin-top: 10px;\n}\n\n.info-label {\n  width: 35%;\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: normal;\n  color: rgb(51, 51, 51);\n}\n\n.info-value {\n  width: 65%;\n  float: right;\n  word-wrap: break-word;\n  line-height: 1.5;\n  font-size: 14px;\n  font-weight: normal;\n  color: rgb(51, 51, 51);\n}\n\n.info-section-content {\n  margin: 14px 5px 0 35px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
